import route from "@/components/router/Router"
const routes = [
    {
        path : "officebuilding-item-add",
        name : "officebuilding-item-add",
        meta : {
            title : "写字楼项目-项目录入"
        },
        component: () => import('@/pages/officebuilding/input/Index')
    },
    {
        path : "officebuilding-item-edit/:id",
        name : "officebuilding-item-edit",
        meta : {
            title : "写字楼项目-项目录入"
        },
        component: () => import('@/pages/officebuilding/input/Index')
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/officebuilding/inputitem/index.js